import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoDocumentiDoganaliRicevutiStep2Component
} from './conservazione-carica-documento-documenti-doganali-ricevuti-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-documenti-doganali-ricevuti-step2', {
            url: '/conservazione-carica-documenti-doganali-ricevuti',
            ncyBreadcrumb: {
                label: 'Carica Documenti Doganali Ricevuti',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-documenti-doganali-ricevuti-step2 flex="100"></conservazione-carica-documento-documenti-doganali-ricevuti-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoDocumentiDoganaliRicevutiStep2Module: string = ng
    .module('conservazione-carica-documento-documenti-doganali-ricevuti-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoDocumentiDoganaliRicevutiStep2', ConservazioneCaricaDocumentoDocumentiDoganaliRicevutiStep2Component)
    .config(stateConfig)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-documenti-doganali-ricevuti-step2/conservazione-carica-documento-documenti-doganali-ricevuti-step2.module.ts